import React from 'react';

import { Button } from '@metarouter-private/mr-mui';

import useEventDebuggerTableRefreshButtonProps from './useEventDebuggerTableRefreshButtonProps';

export default function EventDebuggerTableRefreshButton() {
  const refreshButtonProps = useEventDebuggerTableRefreshButtonProps();
  return <Button {...refreshButtonProps}>Refresh</Button>;
}
